module.exports = __webpack_public_path__ + "static/media/ProximaNova-RegularIt.c88bf689.woff";